import store from "@/store";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/login",
    name: "CustomerLogin",
    component: () => import("../views/CustomerLogin.vue")
  },
  {
    path: "/subcontractor/login",
    name: "SubcontractorLogin",
    component: () => import("../views/SubcontractorLogin.vue")
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue")
  },
  {
    path: "/verificationError",
    name: "VerificationError",
    component: () => import("../views/VerificationError.vue")
  },
  /*****************
   * customer
   */
  {
    path: "/customer/home",
    name: "CustomerHome",
    meta: { requiresAuthCustomer: true },
    component: () => import("../views/customer/Home.vue")
  },
  /*****************
   * subcontractor
   */
  {
    path: "/subcontractor/home",
    name: "SubcontractorHome",
    meta: { requiresAuthSubcontractor: true },
    component: () => import("../views/subcontractor/Home.vue")
  },
  {
    path: "/subcontractor/image/create",
    name: "SubcontractorImageCreate",
    meta: { requiresAuthSubcontractor: true },
    component: () => import("../views/subcontractor/image/ImageCreate.vue")
  },

  /*****************
   * users
   */
  // Site
  {
    path: "/site/list",
    name: "SiteList",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/Index.vue")
  },
  {
    path: "/site/create",
    name: "SiteCreate",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/Create.vue")
  },
  {
    path: "/site/:site_id",
    name: "SiteDetail",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/Index.vue")
  },
  {
    path: "/site/:site_id/edit",
    name: "SiteEdit",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/Edit.vue")
  },
  // Cost
  {
    path: "/cost/",
    name: "CostList",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/cost/Index.vue")
  },
  {
    path: "/site/:site_id/cost/create/",
    name: "SiteCostCreate",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/CostCreate.vue")
  },
  {
    path: "/cost/:cost_id/edit/",
    name: "CostEdit",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/cost/_id/Edit.vue")
  },
  {
    path: "/site/:site_id/cost/",
    name: "SiteCostList",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/CostList.vue")
  },
  {
    path: "/site/:site_id/cost/all",
    name: "SiteCostAllList",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/CostAllList.vue")
  },

  // {
  //   path: "/site/:site_id/cost/today",
  //   name: "SiteCostTodayList",
  //   meta: { requiresAuthUser: true },
  //   component: () => import("../views/user/site/_id/CostTodayList.vue")
  // },
  // mori test
  // {
  //   path: '/input1',
  //   component: () => import("../components/user/forms/items/InputDate.vue"),
  // },
  // {
  //   path: '/with_vuex/input2',
  //   component: WithVuexInput2
  // },
  // {
  //   path: '/with_vuex/confirm',
  //   component: WithVuexConfirm
  // },
  // {
  //   path: '/with_vuex/complete',
  //   component: WithVuexComplete
  // }

  // Image
  {
    path: "/site/:site_id/image/list",
    name: "SiteImageList",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/ImageIndex.vue")
  },

  {
    path: "/site/:site_id/image/create/",
    name: "SiteImageCreate",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/ImageCreate.vue")
  },
  {
    path: "/site/:site_id/image/edit",
    name: "SiteImageEdit",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/ImageEdit.vue")
  },
  {
    path: "/image/edit/:image_id",
    name: "ImageEdit",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/image/_id/Edit.vue")
  },
  // Manifest
  {
    path: "/site/:site_id/manifest/list",
    name: "SiteManifestList",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/ManifestIndex.vue")
  },
  {
    path: "/site/:site_id/manifest/edit",
    name: "SiteManifestEdit",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/site/_id/ManifestEdit.vue")
  },
  {
    path: "/manifest/edit/:image_id",
    name: "MainfestEdit",
    meta: { requiresAuthUser: true },
    component: () => import("../views/user/image/_id/Edit.vue")
  },

  /*****************
   * admin
   */
  {
    path: "/admin/home",
    name: "AdminHome",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/Home.vue")
  },
  // {
  //   path: "/admin/home",
  //   name: "AdminHome",
  //   meta: { requiresAuthAdmin: true },
  //   component: () => import("../views/admin/Home.vue")
  // },

  // {
  //   path: "/admin/home",
  //   name: "AdminHome",
  //   meta: { requiresAuthAdmin: true },
  //   component: () => import("../views/admin/site/Index.vue")
  // },

  {
    path: "/admin/setting",
    name: "AdminSetting",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/Setting.vue")
  },
  {
    path: "/admin/setting/company",
    name: "AdminCompanyDetail",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/company/_id/Index.vue")
  },
  {
    path: "/admin/setting/customer/list",
    name: "AdminCustomerList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/customer/Index.vue")
  },
  {
    path: "/admin/setting/customer/create",
    name: "AdminCustomerCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/customer/Create.vue")
  },
  {
    path: "/admin/setting/customer/:user_id/edit",
    name: "AdminCustomerEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/customer/_id/Edit.vue")
  },
  {
    path: "/admin/setting/subcontractor/list",
    name: "AdminSubcontractorList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/subcontractor/Index.vue")
  },
  {
    path: "/admin/setting/subcontractor/create",
    name: "AdminSubcontractorCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/subcontractor/Create.vue")
  },
  {
    path: "/admin/setting/subcontractor/:user_id/edit",
    name: "AdminSubcontractorEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/subcontractor/_id/Edit.vue")
  },

  {
    path: "/admin/setting/company/edit",
    name: "AdminCompanyEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/company/_id/Edit.vue")
  },

  {
    path: "/admin/setting/company/image/create",
    name: "AdminCompanyImageCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/company/_id/ImageCreate.vue")
  },

  {
    path: "/admin/setting/stage/list",
    name: "AdminStageList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/stage/Index.vue")
  },
  {
    path: "/admin/setting/stage/edit/:stage_id",
    name: "AdminStageEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/stage/_id/Edit.vue")
  },
  {
    path: "/admin/setting/stage/create",
    name: "AdminStageCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/stage/Create.vue")
  },
  {
    path: "/admin/site/list",
    name: "AdminSiteListHome",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/SiteListHome.vue")
  },
  {
    path: "/admin/site/progress",
    name: "AdminSiteProgress",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/Progress.vue")
  },
  {
    path: "/admin/site/completion",
    name: "AdminSiteCompletion",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/Completion.vue")
  },
  {
    path: "/admin/site/billed",
    name: "AdminSiteBilled",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/Billed.vue")
  },
  {
    path: "/admin/site/create",
    name: "AdminSiteCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/Create.vue")
  },
  {
    path: "/admin/site/:site_id",
    name: "AdminSiteDetail",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/_id/Index.vue")
  },
  {
    path: "/admin/site/:site_id/edit",
    name: "AdminSiteEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/_id/Edit.vue")
  },
  {
    path: "/admin/site/:site_id/report/",
    name: "AdminSiteReport",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/_id/Report.vue")
  },

  // Cost
  {
    path: "/admin/cost/list",
    name: "AdminCostList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/cost/Index.vue")
  },
  {
    path: "/admin/site/:site_id/cost/",
    name: "AdminSiteCostList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/_id/CostList.vue")
  },
  {
    path: "/admin/site/:site_id/cost/create",
    name: "AdminSiteCostCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/_id/CostCreate.vue")
  },
  {
    path: "/admin/cost/create",
    name: "AdminCostCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/cost/Create.vue")
  },
  {
    path: "/admin/cost/:cost_id/edit",
    name: "AdminCostEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/cost/_id/Edit.vue")
  },
  // CostIndex
  {
    path: "/admin/partner/:partner_id/cost_index/create",
    name: "AdminCostIndexCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/cost_index/Create.vue")
  },
  {
    path: "/admin/cost_index/:cost_index_id/edit",
    name: "AdminCostIndexEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/cost_index/_id/Edit.vue")
  },
  // Image
  {
    path: "/admin/site/:site_id/image/list",
    name: "AdminSiteImageList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/_id/ImageIndex.vue")
  },

  {
    path: "/admin/site/:site_id/image/create",
    name: "AdminSiteImageCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/_id/ImageCreate.vue")
  },
  // {
  //   path: "/admin/site/:site_id/image/edit",
  //   name: "AdminSiteImageEdit",
  //   meta: { requiresAuthAdmin: true },
  //   component: () => import("../views/admin/site/_id/ImageEdit.vue")
  // },
  {
    path: "/admin/image/edit/:image_id",
    name: "AdminImageEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/image/_id/Edit.vue")
  },
  // Manifest
  {
    path: "/admin/site/:site_id/manifest/list",
    name: "AdminSiteManifestIndex",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/_id/ManifestIndex.vue")
  },
  {
    path: "/admin/site/:site_id/manifest/create",
    name: "AdminSiteManifestCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/site/_id/ManifestCreate.vue")
  },
  {
    path: "/admin/manifest/edit/:image_id",
    name: "AdminManifestEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/image/_id/Edit.vue")
  },

  // Category
  {
    path: "/admin/category/list",
    name: "AdminCategoryList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/category/Index.vue")
  },
  {
    path: "/admin/category/create",
    name: "AdminCategoryCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/category/Create.vue")
  },
  {
    path: "/admin/category/:category_id/edit",
    name: "AdminCategoryEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/category/_id/Edit.vue")
  },
  // Partner
  {
    path: "/admin/partner/list",
    name: "AdminPartnerList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/partner/Index.vue")
  },
  {
    path: "/admin/partner/create",
    name: "AdminPartnerCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/partner/Create.vue")
  },
  {
    path: "/admin/partner/:partner_id",
    name: "AdminPartner",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/partner/_id/Index.vue")
  },
  {
    path: "/admin/partner/:partner_id/edit",
    name: "AdminPartnerEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/partner/_id/Edit.vue")
  },
  // User
  {
    path: "/admin/user/list",
    name: "AdminUserList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/user/Index.vue")
  },
  {
    path: "/admin/user/create",
    name: "AdminUserCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/user/Create.vue")
  },
  {
    path: "/admin/user/:user_id/edit",
    name: "AdminUserEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/user/_id/Edit.vue")
  },
  // Contractor
  {
    path: "/admin/contractor/list",
    name: "AdminContractorList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/contractor/Index.vue")
  },
  {
    path: "/admin/contractor/create",
    name: "AdminContractorCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/contractor/Create.vue")
  },
  {
    path: "/admin/contractor/:contractor_id",
    name: "AdminContractorDetail",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/contractor/_id/Index.vue")
  },
  {
    path: "/admin/contractor/:contractor_id/edit",
    name: "AdminContractorEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/contractor/_id/Edit.vue")
  },
  // Staff
  {
    path: "/admin/staff/list",
    name: "AdminStaffList",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/staff/Index.vue")
  },
  {
    path: "/admin/contractor/:contractor_id/staff/create",
    name: "AdminStaffCreate",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/staff/Create.vue")
  },
  {
    path: "/admin/staff/:staff_id/edit",
    name: "AdminStaffEdit",
    meta: { requiresAuthAdmin: true },
    component: () => import("../views/admin/staff/_id/Edit.vue")
  },

  // verify
  {
    path: "/verified",
    name: "Verified",
    component: () => import("../views/admin/Verified.vue")
  },

  {
    path: "*",
    name: "notFound",
    component: () => import("../views/Login.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuthAdmin)) {
    if (!store.getters["auth/isAdmin"]) {
      store.commit("login/redirectUrl", to.fullPath);
      next({
        name: "Login"
      });
    } else if (!store.getters["auth/isVerifed"]) {
      next({
        name: "VerificationError"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresAuthUser)) {
    if (!store.getters["auth/isUser"]) {
      store.commit("login/redirectUrl", to.fullPath);
      next({
        name: "Login"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresAuthCustomer)) {
    if (!store.getters["auth/isCustomer"]) {
      store.commit("login/redirectUrl", to.fullPath);
      next({
        name: "CustomerLogin"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresAuthSubcontractor)) {
    if (!store.getters["auth/isSubcontractor"]) {
      store.commit("login/redirectUrl", to.fullPath);
      next({
        name: "SubcontractorLogin"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters["auth/isAuthorized"]) {
      store.commit("login/redirectUrl", to.fullPath);
      next({
        name: "Login"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
